import type { StaticPageRecord } from './types'

export const staticPages: readonly StaticPageRecord[] = [
  {
    slug: 'contact-us',
    name: 'Contact Us',
    eyebrow: 'We are here to help',
    summary: 'Call, email, or visit Pack Print Mail in Waxahachie for service information and availability.',
  },
  {
    slug: 'file-upload',
    name: 'File Upload',
    eyebrow: 'Send us your print files',
    summary: 'A secure file-upload workflow will be connected in a later milestone.',
  },
  {
    slug: 'ipostal1',
    name: 'iPostal1',
    eyebrow: 'Digital mailbox services',
    summary: 'Digital mailbox information and enrollment details will be added here after confirmation.',
  },
]
